// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__ZsWRs","message":"style__message__v3+1D"};